module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Oeschgen-96dbd6674e6a5083babc82a260f5ac5d.svg";